<template>
  <div>
    <template v-if="user.permissionLevel === 1">
      <GridSeparator separatorName="Tableau de bord" />
      <RemediationTable />
      <SelectGridSeparator />
      <a-spin :spinning="loading">
        <a-icon slot="indicator" type="loading" style="font-size: 48px" spin />
        <WorkGrid/>
      </a-spin>
    </template>
    <template v-else>
      <GridSeparator separatorName="Tous mes travaux" />
      <a-spin :spinning="loading">
        <a-icon slot="indicator" type="loading" style="font-size: 48px" spin />
        <WorkGrid/>
      </a-spin>
    </template>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapState } from 'vuex'
import WorkGrid from '@/components/work/WorkGrid.vue'
import GridSeparator from '@/components/GridSeparator.vue'
import SelectGridSeparator from '@/components/SelectGridSeparator'
import RemediationTable from '@/components/RemediationTable'

export default {
  name: 'Works',
  components: {
    WorkGrid,
    GridSeparator,
    SelectGridSeparator,
    RemediationTable
  },
  computed: {
    ...mapState({
      darkTheme: state => state.darkTheme,
      user: state => state.auth.user,
      loading: state => state.work.loading
    })
  },
  created () {
    document.title = 'JT - Home'
  }
}
</script>

<style scoped lang="scss">
</style>
